RivalIQ.module('adBlockerDetector', function (adBlockerDetector, App, Backbone, Marionette, $, _) {

    'use strict';

    // Don't show the general ad blocker nag if we've already shown it in the last 2 weeks.
    const AD_BLOCKER_NAG_TIMEOUT_WEEKS = 2;

    // How long to wait to see if our test ad div was blocked.
    const AD_BLOCKER_DOM_TEST_TIMEOUT_MS = 250;

    const AD_BLOCKER_NAG_LAST_SHOWN_KEY = 'AdBlockerLastNag';

    let lastCurationIdNagged = undefined;


    // Returns a promise that resolves to true if an adblocker is enabled, false otherwise.
    // Based on https://stackoverflow.com/questions/4869154/how-to-detect-adblock-on-my-website
    adBlockerDetector.checkAdBlockerEnabled = function () {

        const deferred = new $.Deferred();

        const test = document.createElement('div');
        test.innerHTML = '&nbsp;';
        test.className = 'adsbox';
        document.body.appendChild(test);
        window.setTimeout(function () {
            const isAdBlockerEnabled = (test.offsetHeight === 0);

            // IE doesn't support remove() natively, so we'll use jQuery's instead.
            $(test).remove();
            deferred.resolve(isAdBlockerEnabled);
        }, AD_BLOCKER_DOM_TEST_TIMEOUT_MS);

        return deferred;
    };

    adBlockerDetector._showAdBlockerNag = _.debounce(function (message, trackingData) {
        RivalIQ.execute('alert:info', message);

        RivalIQ.execute('persistence:user:save', function (userSettings) {
            userSettings[AD_BLOCKER_NAG_LAST_SHOWN_KEY] = new Date();
        });

        RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedAdBlockerNag, trackingData);
    }, 2000, {
        leading: true,
        trailing: false
    });

    // If it's been more than AD_BLOCKER_NAG_TIMEOUT_WEEKS weeks and the user has an ad blocker enabled, show a nag.
    adBlockerDetector.checkAndShowAdBlockerNag = function () {

        // Determine if enough time has elapsed since we last showeed this user a nag.
        const userSettings = RivalIQ.settings.userSettings || {};
        const value = userSettings[AD_BLOCKER_NAG_LAST_SHOWN_KEY];
        const canShowNag = (!value || moment(value).add(AD_BLOCKER_NAG_TIMEOUT_WEEKS, 'week').toDate() < new Date());

        if (canShowNag) {
            adBlockerDetector.checkAdBlockerEnabled()
                .then(function (isAdBlockerEnabled) {
                    if (isAdBlockerEnabled) {
                        adBlockerDetector._showAdBlockerNag(RivalIQ.strings.ad_blocker_nag_message);
                    }
                });
        }
    };

    // If the user has an ad blocker enabled, show a nag. This function takes in a curationId that it stores in memory; if we last
    // showed the ad blocker nag for this curation id, we won't show it again. This is to prevent the nag from firing over and over
    // again as the user navigates around an app.
    // This function returns a function that takes no arguments and returns nothing (suitable for a curation before filter).
    adBlockerDetector.checkAndShowAdBlockerForCuration = function (curationId, message) {
        return function (curation) {
            if (curation.isExporting() || RivalIQ.state.account.isImpersonated() || lastCurationIdNagged === curationId) {
                return;
            }

            lastCurationIdNagged = curationId;
            adBlockerDetector.checkAdBlockerEnabled()
                .then(function (isAdBlockerEnabled) {
                    if (isAdBlockerEnabled) {
                        adBlockerDetector._showAdBlockerNag(message, {
                            curationId: curationId
                        });
                    }
                });
        };
    };
});
